<template>
  <div id="footer">
    <!-- <div class="row">

    </div> -->
    <div class="footer-body">
      <ul class="header-nav-wrapper">
        <li
          v-for="(item, index) in test"
          :key="index"
        >
          <div>
            <a @click="navClick(index, item)">
              {{ item.meta.title }}
            </a>

            <div
            v-if="typeDl&&heightDl==index &&item.list && item.list.length > 0"
              class="glyphicon glyphicon-menu-up"
              @click="upFeightdl(index)"
            ></div>
            <div
            v-else-if="item.list && item.list.length > 0"
              class="glyphicon glyphicon-menu-down"
              @click="downFeightdl(index)"
            ></div>
          </div>
          <dl
            :class="'dl-type'+index"
            v-if="item.list && item.list.length > 0"
          >
            <dt
              v-for="(i, n) in item.list"
              :key="n"
              @click="getComindex(n, item, index)"
            >
              <a>{{ i.meta.title }}</a>
            </dt>
          </dl>
        </li>
      </ul>

      <div class="weixin-img">
        <p class=" hidden-xs">{{ $t('home.about') }}</p>
        <div class="img-about">
          <div
            v-for="(item, index) in imgList"
            :key="index"
          >
            <div>
<!--              <vue-qr-->
<!--                ref="qrCode"-->
<!--                :text="item.text"-->
<!--                :size="160"-->
<!--                :logoSrc="item.logoSrc"-->
<!--                :logoCornerRadius="2"-->
<!--                :logoMargin="4"-->
<!--                :margin="10"-->
<!--              ></vue-qr>-->

              <img :src="item.qrCode"/>
              <div>{{item.name}}</div>
            </div>
            <span>
              {{ item.title }}
            </span>
          </div>
        </div>
      </div>
<!--      <div class="bottom-line">-->
<!--        <div v-html="dsss">-->

<!--        </div>-->
<!--        <p>-->
<!--          福建海峡人力资源股份有限公司-->
<!--        </p>-->
<!--        <p>-->
<!--          备案/许可证编号为:闽ICP备2022004362号-4-->
<!--        </p>-->
<!--      </div>-->

    </div>
    <!-- <div class="move-footer">
      <el-collapse v-model="activeName" accordion>
        <div v-for="(item, index) in test" :key="index">
          <el-collapse-item :title="item.meta.title" @change="navClick(index, item)" :name="index + 1 + ''">
            <div v-if="item.list && item.list.length">
              <div v-for="(it, n) in item.list" :key="n">
                <a @click="getComindex(n, item, index)">{{ it.meta.title }}</a>
              </div>
            </div>

          </el-collapse-item>
        </div>

      </el-collapse>
    </div> -->
  </div>
</template>
<script>
import VueQr from 'vue-qr';
import { WOW } from 'wowjs';
import {Message} from "element-ui";
import api from "@/api/api";
export default {
  name: "Footer",
  components: {
    VueQr
  },
  data() {
    return {
      activeName: '1',
      dsss: '',
      heightDl: null,
      typeDl:false,
      imgList: [
      ],

    };
  },
// {
//   text: '1234567890',
//     logoSrc: require('../assets/img/erweima.jpg'),
//   title: 'Interactive platform'
// },
  computed: {
    test() {
      let list = [ ...this.$store.state.routes ];
      list.shift();
      return list;
    }
  },
  mounted() {
    var wow = new WOW({
      boxClass: 'wow',
      animateClass: 'animated',
      offset: 0,
      mobile: true,
      live: true
    });
    wow.init();
    this.getQr()
  },
  methods: {
    getQr(){
      api.selectQrCodeList({language: this.$store.state.lang}).then(res =>{
       this.imgList = res.data.data
      })
    },
    navClick(index, item) {
      this.$store.commit('setNavIndex', index + 1);
      sessionStorage.setItem('navIndex', index + 1);
      this.$store.commit('setComIndex', 0);
      if (this.$store.state.routePath === item.path) return;
      this.$store.commit('setRoutePath', item.path);
      this.$router.push({
        path: item.path
      });
    },
    getComindex(index, item, routeIndex) {
      this.$store.commit('setNavIndex', routeIndex + 1);
      sessionStorage.setItem('navIndex', routeIndex + 1);
      this.$store.commit('setComIndex', index);
      if (this.$store.state.routePath === item.path) return;
      this.$store.commit('setRoutePath', item.path);
      this.$router.push({
        path: item.path
      });
    },

    downFeightdl(val) {

      if (this.heightDl != null) {
        $(`.dl-type${ this.heightDl }`).css('height', '0px');
        $(`.dl-type${ this.heightDl }`).css('padding', '0px');
        $(`.dl-type${ this.heightDl }`).css('visibility', 'hidden');
      }
      $(`.dl-type${ val }`).css('height', '100%');
      $(`.dl-type${ val }`).css('padding', '10px 0');
      $(`.dl-type${ val }`).css('visibility', 'inherit');
      this.heightDl = val;
      this.typeDl=true
    },
    upFeightdl(val) {
      $(`.dl-type${ val }`).css('height', '0');
      $(`.dl-type${ val }`).css('padding', '0');
      $(`.dl-type${ val }`).css('visibility', 'hidden');
      this.heightDl = val;
      this.typeDl=false
    },
  }
  // watch: {
  //   test: {
  //     immediate: true,
  //     handler: function (newval) {
  //       this.navList = [
  //         {
  //           name: "HomePage",
  //           path: "/HomePage",
  //           list: [],
  //           meta: {
  //             title: '首页'
  //           }
  //         },
  //         ...newval];
  //       console.log(this.$router);
  //     }
  //   }
  // },
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff !important;
  background: #02061fe1;
  overflow: hidden;
  text-align: center;
}

.footer-body {
  display: flex;
  padding: 60px 0 20px 0;
  justify-content: space-between;
  flex-wrap: wrap;
}

.header-nav-wrapper {
  display: flex;
  width: 60%;
  justify-content: space-around;
  color: #fff !important;
}

li > div > a {
  text-decoration: none;
  color: #fff;
  font-size: 15px;
}

dt {
  margin: 15px 0;
}

dt > a {
  color: #ffffff81;
}

.weixin-img {
  text-align: left;
  width: 30%;
}

/* .weixin-img > p {
  opacity: 0.6;
} */

.img-about {
  display: flex;
}

.img-about > div {
  text-align: center;
  margin: 0 5px 5px 0;
  color: #c4c2c2;
}

.img-about > div > div {
  border: 1px solid #2525251b;
  border-radius: 4px;
}

.bottom-line {
  border-top: 2px solid rgba(0, 0, 0, .2);
  width: 100%;
  margin-top: 20px;
  padding: 50px 0 30px;
  color: #c4c2c2;
}

.move-footer {
  display: none;
}

@media screen and (max-width: 1440px) {
  .footer-body {
    display: block;
    width: 100%;
  }

  .header-nav-wrapper {
    width: 100%;
    display: block;
  }
  .header-nav-wrapper > li {
    text-align: left;
    /* padding: 10px 0 ; */
    border-top: 1px solid #c4c2c2;
    border-bottom: 1px solid #c4c2c2;
    margin: -1px 0;
  }
  .header-nav-wrapper > li > div {
    margin: 15px;
    display: flex;
    justify-content: space-between;
  }
  .header-nav-wrapper > li > dl {
    padding: 0px 0;
    height: 0;
    visibility: hidden;
    background: white;
    margin: 0;
    /* transition:all 2s ease; */
  }

  .header-nav-wrapper > li > dl dt {
    /* margin: 10px 0 0px; */
    padding: 5px 40px 10px;
  }
  .header-nav-wrapper > li > dl > dt > a {
    color: #323232;
  }

  .el-collapse-item {
    padding: 1px 0px;
  }

  .el-collapse {
    border-top: 0px;
  }
  .weixin-img{
    padding: 50px 0;
    margin: auto;
    text-align: right;
    width: 50%;
  }
  .weixin-img>p{
    margin-right: -60px;
    /* margin-left: 80px; */
  }
  .img-about{
    justify-content: right;

  }
  .img-about>div{
    margin-right: -60px;
    margin-left: 80px;
  }
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }

  .address_tel_fax {
    font-size: 12px;
  }

  .email_wx {
    font-size: 12px;
  }

  .copy {
    font-size: 12px;
    margin: 30px 0 10px;
  }

  .header-nav-wrapper > li > div {
    margin: 10px;
    display: flex;
    justify-content: space-between;
  }
  li > div > a {
    text-decoration: none;
    color: #fff;
    font-size: 12px;
  }
  .header-nav-wrapper > li > dl dt {
    /* margin: 10px 0 0px; */
    padding: 0px 15px 5px;
  }
  dt {
    margin: 5px 0;
  }
  .footer-body {
    padding: 0px 0 20px 0;
  }
}

@media screen and (max-width: 768px) {
  .weixin-img{
    padding:0px ;
    margin: -10px 0;
    /* margin: 0 auto; */
    width: 100%;
    transform: scale(.5);
  }
  .img-about{
    justify-content: right;
  }
  .img-about>div{
    margin-right: -60px;
    margin-left: 80px;
  }
}

</style>




// WEBPACK FOOTER //
// src/components/Footer.vue